import { render, staticRenderFns } from "./AddDiferenciais.vue?vue&type=template&id=3a9ee2c8&"
import script from "./AddDiferenciais.vue?vue&type=script&lang=js&"
export * from "./AddDiferenciais.vue?vue&type=script&lang=js&"
import style0 from "./AddDiferenciais.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports